<template>
  <div class="loan-card">
    <div class="loan-content">
      <div class="load-amount-title">可用额度(元)</div>
       <div class="load-amount ali-bold-text">{{ amountFormatter(pendingPlan.remainCreditAmount) || '---' }}</div>
        <div class="load-amount-tip">
          最小借贷金额<span>{{ amountFormatter(pendingPlan.minBorrowAmount) || '---' }}</span
          >/最多同时借<span>{{ pendingPlan.multipleLimitNum || '---' }}</span
          >笔
        </div>
        <div class="loan-content-wrap">
           <div class="load-heand-info">
          <div class="info-item">
            <span>年利率：</span>
            <span>{{ pendingPlan.annualizedRatio || '---' }}%</span>
          </div>
          <div class="step-img">
           |
          </div>
          <div class="info-item">
            <span>还款期数：</span>
            <span>{{ pendingPlan.issueOrderNum || '---' }}期</span>
          </div>
          <div class="step-img">
           |
          </div>
          <div class="info-item">
            <span>每期天数：</span>
            <span>{{ pendingPlan.issueDay || '---' }}天</span>
          </div>
        </div>
        <div class="load-card-tab">
          <div class="tab-item" @click="handSelectCard">
            <div class="top">
              <div
                class="tab-item-left"
                :style="{ color: bankInfo.bankName ? '#333333' : '#FF0000' }"
              >
                <span>收款账户</span>
                <img src="@/assets/style/card-icon.png" alt="" />
              </div>
              <div class="tab-item-right">
                <span class="span">{{ bankInfo.bankName ? "换卡" : "绑定" }}</span>
                <img src="@/assets/style/load/loac-card-right.png" alt="" />
              </div>
            </div>
            <div class="bottom" v-if="bankInfo.bankName">
              <span>{{ maskBankCard(receivedBank.bankNumber) || maskBankCard(bankInfo.bankNumber) || "无" }}</span>
            </div>
            <div class="no-bank" style="color: #ff0000" v-else>
              <span>---</span>
            </div>
          </div>
          <div class="tab-item" @click="handApplicationList">
            <div class="top">
              <div class="tab-item-left">
                <span>用途</span>
                <img src="@/assets/style/application-icon.png" alt="" />
              </div>
              <div class="tab-item-right">
                <span class="span">更多</span>
                <img src="@/assets/style/load/loac-card-right.png" alt="" />
              </div>
            </div>
            <div class="bottom">
              <span>{{ borrowPurpose || "个人消费" }}</span>
            </div>
          </div>
        </div>
        </div>
      </div>
      <!--选择银行卡-->
      <selectBankCardPopup ref="selectBankCardPopupRef" />
      <!--选择用途-->
      <selectUseList ref="selectUseListRef" />
  </div>
</template>

<script>
import selectBankCardPopup from "@/components/loan/selectBankCardPopup.vue";
import selectUseList from "@/components/loan/selectUseList.vue";
import { maskBankCard } from "@/utils/utils";
import { amountFormatter } from "@/utils/utils";

export default {
  name: "LoanCard",
  components: {
    selectBankCardPopup,
    selectUseList,
  },
  props: {
    pendingPlan: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      maskBankCard,
      amountFormatter,
    };
  },
  async mounted() {},
  methods: {
    handApplicationList() {
      this.$refs.selectUseListRef.init();
    },
    handSelectCard() {
      if (this.bankInfo.bankName) {
        this.$refs.selectBankCardPopupRef.init();
      } else {
        this.$router.push({
          name: "bankCardBinding",
          query: {
            type: "bankBind",
          },
        });
      }
    },
  },
  computed: {
    bankInfo() {
      return this.$store.getters.bankInfo;
    },
    borrowPurpose() {
      return this.$store.getters.borrowPurpose;
    },
    receivedBank() {
      return this.$store.getters.receivedBank;
    }
  },
};
</script>

<style scoped lang="scss">

.load-amount-title,
.load-amount,
.load-amount-tip {
  font-size: 14px;
  color: #fff;
}
.load-amount-title {
  font-size: 16px;
}
.load-amount {
  font-weight: 600;
  font-size: 40px;
}
.load-amount-tip {
  font-size: 12px;
}
.loan-content-wrap{
  background: linear-gradient( 180deg, #FF8371 0%, rgba(255,131,113,0) 100%);
  border-radius: 8px 8px 8px 8px;
  margin-top: 17px;
  .load-heand-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 11px;
    .info-item {
      font-size: 13px;
      color: #fff;
      display: flex;
      align-items: center;
    }
    .step-img {
      display: flex;
      align-items: center;
      color: rgba(255,255,255,0.4);
    }
    .step1-img {
      display: flex;
      align-items: center;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
}
.load-card-tab {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tab-item {
    width: 43%;
    height: 46px;
    background: #fff;
    border-radius: 8px;
    padding: 7px 9px 9px 11px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tab-item-left,
      .tab-item-right {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-left: 4px;
        }
        .span {
          color: #D4A038;
          font-size: 14px;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #777777;
    }
  }
}
</style>
